@if (message.body) {
  <div [ngClass]="'alert alert-' + message.type" [ngStyle]="{ 'z-index': 999999 }" role="alert">
  <i class="fa me-2" [ngClass]="{
    'fa-check-circle': message.type === 'success',
    'fa-exclamation-circle': message.type === 'warning' || message.type === 'danger'
  }"></i>
    <span [innerHTML]="message.body"></span>
  </div>
}